// removed by extract-text-webpack-plugin
module.exports = {"root":"SortLabel__root___2jI47","asc":"SortLabel__asc___3liI2","optionsContainer":"SortLabel__optionsContainer___1j1rk","optionsOpen":"SortLabel__optionsOpen___1f6Oc","option":"SortLabel__option___YZ-er","optionCheckbox":"SortLabel__optionCheckbox___1gaPs"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/SortLabel/SortLabel.scss
 ** module id = 1241
 ** module chunks = 0
 **/